import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { useState, useEffect } from 'react'

function OrderBook({futureasset}) {
  const [orderData, setOrderData] = useState({
    topRows: Array(9).fill().map(() => {
      const priceDelta = (Math.random() * 0.08 + 0.01) * (Math.random() < 0.5 ? -1 : 1);
      const qtyDelta = (Math.random() * 0.0008 + 0.0001) * (Math.random() < 0.5 ? -1 : 1);
      return {
        price: (Number(futureasset.price) + priceDelta).toFixed(2),
        quantity: ((500 / Number(futureasset.price)) + qtyDelta).toFixed(4),
      };
    }),
    bottomRows: Array(8).fill().map(() => {
      const priceDelta = (Math.random() * 0.08 + 0.01) * (Math.random() < 0.5 ? -1 : 1);
      const qtyDelta = (Math.random() * 0.0008 + 0.0001) * (Math.random() < 0.5 ? -1 : 1);
      return {
        price: (Number(futureasset.price) + priceDelta).toFixed(2),
        quantity: ((500 / Number(futureasset.price)) + qtyDelta).toFixed(4),
        change : false
      };
    })
  });
  useEffect(() => {
    if (!futureasset) return;
    setOrderData({
      topRows: Array(9).fill().map(() => {
        const priceDelta = (Math.random() * 0.08 + 0.01) * (Math.random() < 0.5 ? -1 : 1);
        const qtyDelta = (Math.random() * 0.0008 + 0.0001) * (Math.random() < 0.5 ? -1 : 1);
        return {
          price: (Number(futureasset.price) + priceDelta).toFixed(2),
          quantity: ((500 / Number(futureasset.price)) + qtyDelta).toFixed(4),
          priceExpires: 0,
          qtyExpires: 0,
          priceChange: false,
          qtyChange: false
        };
      }),
      bottomRows: Array(8).fill().map(() => {
        const priceDelta = (Math.random() * 0.08 + 0.01) * (Math.random() < 0.5 ? -1 : 1);
        const qtyDelta = (Math.random() * 0.0008 + 0.0001) * (Math.random() < 0.5 ? -1 : 1);
        return {
          price: (Number(futureasset.price) + priceDelta).toFixed(2),
          quantity: ((500 / Number(futureasset.price)) + qtyDelta).toFixed(4),
          priceExpires: 0,
          qtyExpires: 0,
          priceChange: false,
          qtyChange: false
        };
      })
    });
  }, [futureasset?.price, futureasset?.symbol]);
  useEffect(() => {
    const interval = setInterval(() => {
      setOrderData(prev => {
        const MIN_PRICE = 0.01;
        const MIN_QTY = 0.0001;
        const HIGHLIGHT_MS = 1000;
        const now = Date.now();
        const updateRow = (row) => {
          let currentPrice = parseFloat(row.price);
          let currentQty = parseFloat(row.quantity);
          let newPrice = currentPrice;
          let newQty = currentQty;
          let priceExpires = row.priceExpires ?? 0;
          let qtyExpires = row.qtyExpires ?? 0;
          if (Math.random() > 0.7) {
            const delta = (Math.random() * 0.08 + 0.01) * (Math.random() < 0.5 ? -1 : 1);
            const candidate = currentPrice + delta;
            const clamped = Math.max(candidate, MIN_PRICE);
            newPrice = Number(clamped.toFixed(2));
            priceExpires = now + HIGHLIGHT_MS;
          }
          if (Math.random() > 0.7) {
            const deltaQty = (Math.random() * 0.0008 + 0.0001) * (Math.random() < 0.5 ? -1 : 1);
            const candidateQty = currentQty + deltaQty;
            const clampedQty = Math.max(candidateQty, MIN_QTY);
            newQty = Number(clampedQty.toFixed(4));
            qtyExpires = now + HIGHLIGHT_MS;
          }
          return {
            ...row,
            price: newPrice.toFixed(2),
            quantity: newQty.toFixed(4),
            priceExpires,
            qtyExpires,
            priceChange: priceExpires > now,
            qtyChange: qtyExpires > now
          };
        };
        const updatedTopRows = prev.topRows.map(updateRow);
        const updatedBottomRows = prev.bottomRows.map(updateRow);
        return {
          topRows: updatedTopRows,
          bottomRows: updatedBottomRows
        };
      });
    }, 500);
    return () => clearInterval(interval);
  }, [futureasset.price]);
  const [mainPrice, setMainPrice] = useState(Number(futureasset.price).toFixed(2));
  const [mainColor, setMainColor] = useState(Number(futureasset.percentage) > 0 ? 'success' : 'danger');
  useEffect(() => {
    if (!futureasset) return;
    setMainPrice(Number(futureasset.price).toFixed(2));
    setMainColor(Number(futureasset.percentage) > 0 ? 'success' : 'danger');
  }, [futureasset?.price, futureasset?.percentage]);
  useEffect(() => {
    const interval = setInterval(() => {
      setMainPrice(prev => {
        const previousPrice = parseFloat(prev);
        const priceChange = (Math.random() * 0.04 - 0.02);
        const newPrice = (previousPrice + priceChange).toFixed(2);
        if (priceChange > 0) {
          setMainColor('success');
        } else if (priceChange < 0) {
          setMainColor('danger');
        }
        return newPrice;
      });
    }, 2000);
    return () => clearInterval(interval);
  }, [futureasset.price]);
  const [buyPct, setBuyPct] = useState(50);
  useEffect(() => {
    const MIN = 30;
    const MAX = 70;
    const id = setInterval(() => {
      const newBuy = Math.floor(Math.random() * (MAX - MIN + 1)) + MIN; // 30..70
      setBuyPct(newBuy);
    }, 2000);
    return () => clearInterval(id);
  }, []);
  const sellPct = 100 - buyPct;

  return (
    <div className="mycard p-2 p-md-3 mt-2 orderBook">
      <p className="text-prime fw-bold mb-2">ORDERBOOK</p>
      <div className="d-flex align-items-center justify-content-between mb-1">
        <p className="mb-0 text-secondary" style={{fontSize:'14px',lineHeight:'110%'}}>Price (USDT)</p>
        <p className="mb-0 text-secondary text-end" style={{fontSize:'14px',lineHeight:'110%'}}>Quantity ({futureasset.symbol})</p>
      </div>
      {orderData.topRows.map((row, index) => (
        <div 
          className="d-flex align-items-center justify-content-between fw-semibold" 
          key={`top-${index}`}
        >
          <p 
            className="mb-0 orderb text-danger w-50" 
            style={row.priceChange ? { backgroundColor: '#dc354540', fontSize:'14px' } : {fontSize:'14px'}}
          >
            {row.price}
          </p>
          <p 
            className="mb-0 orderb text-danger w-50 text-end" 
            style={row.qtyChange ? { backgroundColor: '#dc354540', fontSize:'14px' } : {fontSize:'14px'}}
          >
            {row.quantity}
          </p>
        </div>
      ))}
      <div className="d-flex align-items-center justify-content-between my-2">
        <div>
          <p className={`mb-0 text-success fs-4 text-${mainColor} dont`} style={{lineHeight:'120%',fontWeight:'900'}}>{mainPrice}</p>
          <p className="mb-0 fw-semibold lh-1 dont1" style={{fontSize:'13px'}}>{mainPrice}</p>
        </div>
        <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '16px'}} />
      </div>
      {orderData.bottomRows.map((row, index) => (
        <div 
          className="d-flex align-items-center justify-content-between fw-semibold" 
          key={`bottom-${index}`}
        >
          <p 
            className="mb-0 orderb text-success w-50" 
            style={row.priceChange ? { backgroundColor: '#1987546b', fontSize:'14px' } : {fontSize:'14px'}}
          >
            {row.price}
          </p>
          <p 
            className="mb-0 orderb text-success w-50 text-end" 
            style={row.qtyChange ? { backgroundColor: '#1987546b', fontSize:'14px' } : {fontSize:'14px'}}
          >
            {row.quantity}
          </p>
        </div>
      ))}
      <div className='d-flex align-items-center mt-md-3 mt-2 position-relative'>
        <div className='position-absolute rounded-2 border border-2 border-success d-flex align-items-center justify-content-center fw-bold text-success orderBox' style={{left:'-5px',backgroundColor:'#111111'}}>B</div>
        <div className='position-absolute rounded-2 border border-2 border-danger d-flex align-items-center justify-content-center fw-bold text-danger orderBox' style={{right:'-5px',backgroundColor:'#111111'}}>S</div>
        <div className='orderBoxInner' style={{width:`${buyPct}%`,backgroundColor:'rgba(25, 135, 84, 0.42)'}}>
          <p className='mb-0 ms-md-5 ms-4 text-success fw-semibold'>{buyPct}%</p>
        </div>
        <div className='orderBoxInner' style={{width:`${sellPct}%`,backgroundColor:'rgba(220, 53, 69, 0.25)'}}>
          <p className='mb-0 me-md-5 me-4 text-danger text-end fw-semibold'>{sellPct}%</p>
        </div>
      </div>
    </div>
  )
}

export default OrderBook